var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7167 77.2188L89.6382 77.0225L98.5487 33.4513L99.4123 33.2158L98.5487 37.3767L90.384 77.3757L89.9522 77.4935L89.7952 77.3365V77.2972L89.7167 77.2188Z",
    fill: "#323142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4124 31.332V33.2162L98.5488 33.4517V31.5675L99.4124 31.332Z",
    fill: "#4E5067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6267 29.4473L99.4118 31.3314L98.5482 31.567L97.7632 29.6828L98.6267 29.4473Z",
    fill: "#4E5067"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6273 29.4481L97.7638 29.6836L96.5469 28.4668L97.4105 28.2705L98.6273 29.4481Z",
    fill: "#4E5067"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4106 28.2696L96.547 28.4659L48.187 0.556799L49.0506 0.321289L97.4106 28.2696Z",
    fill: "#575974"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0509 0.321858L48.1873 0.557368L46.8135 0.243346L47.6771 0.0078125L49.0509 0.321858Z",
    fill: "#4E5067"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5063 32.6275L96.4671 32.7845L46.9687 4.24743L39.0003 43.3044L38.8433 43.2259L46.8509 3.97266L95.4072 31.9995L96.5063 32.6275Z",
    fill: "#7A8092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8524 3.97225L38.8447 43.2255L38.6484 43.2648L38.6877 43.147L46.7346 3.85449L46.8524 3.97225Z",
    fill: "#3F4046"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5481 31.5673V33.4514L89.6376 77.0226L82.4543 72.901L82.4935 72.7832L89.0881 76.63L97.9986 33.2159V31.6458L97.3705 30.1149L96.3499 29.1336L48.1469 1.30301L46.9301 1.02823L45.9095 1.57776L45.3207 2.79463L37.2345 42.4404L36.4494 46.2087L43.0832 50.0556V50.0948L43.044 50.1341L35.8999 46.0125V45.8947L44.8104 2.40209L45.517 0.949718L46.8123 0.243164L48.1862 0.557185L96.5462 28.4663L97.7631 29.6831L98.5481 31.5673Z",
    fill: "#3E4054"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4673 32.784L96.5065 32.627L95.4075 31.999L46.8511 3.97213L46.6941 3.89362L38.6472 43.1469L38.6079 43.2646L88.3811 71.998L88.4204 71.8803L96.4673 32.784ZM97.9982 31.6457V33.2158L89.1269 76.63L82.5324 72.8224L43.1221 50.0555L36.4883 46.2086L37.2733 42.4403L45.3988 2.83378L45.9876 1.61694L47.0082 1.06738L48.1858 1.34216L96.3888 29.1727L97.4094 30.1933L97.9982 31.6457Z",
    fill: "#474650"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4668 32.7842L88.4591 71.8804L39 43.3041L46.9684 4.24707L96.4668 32.7842Z",
    fill: "#9D9CA7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7563 77.2979H89.7956V77.3371V79.339L87.0871 80.9091L63.4959 94.53L58.4322 97.4348L54.7017 99.6455L54.8602 97.4348L66.4791 90.7225L85.2814 79.8886L89.7563 77.2979Z",
    fill: "#373641"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8395 76.238L38.3728 90.4084L51.2479 82.9503L26.7327 68.9263L13.6433 76.1594L13.8395 76.238ZM65.6146 90.2121L83.7104 79.7708L84.0636 79.5745L84.4169 79.3782L78.4897 75.9632L78.1364 75.7669L39.0794 53.2355L38.7261 53.0393L32.7989 49.6242L32.4456 49.428L32.0923 49.6242L13.6433 60.2619L13.9966 60.4581L14.075 60.4974L14.3498 60.6544L27.0679 67.9948L52.1507 82.4792L65.6146 90.2121ZM81.7869 73.6472L82.3757 73.294L82.7683 73.2547L89.7554 77.337L85.3197 79.8885L66.5174 90.7617L54.8592 97.474L53.2106 98.0235H51.1301L49.4815 97.474L12.7797 76.2772L1.12147 69.5649L0.140137 68.6228V67.4452L1.12147 66.5031L12.7797 59.7908L36.0569 46.3662L36.1747 46.484L43.044 50.4485L43.0047 50.6448L42.3374 51.0373L81.7477 73.765L81.7869 73.6472Z",
    fill: "#474650"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 71.8803V71.998L38.6484 43.2646L39.0017 43.3039L88.4608 71.8803Z",
    fill: "#3B3A3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4165 79.3389L84.0632 79.5745L78.136 76.1594L77.7827 75.9631L38.7257 53.3925L38.3724 53.1962L32.8377 49.9775L32.6414 49.899V49.8597L32.4844 49.3887L32.8377 49.5849L38.7257 53L39.0789 53.1962L78.136 75.7276L78.4892 75.9631L84.4165 79.3389Z",
    fill: "#545673"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0646 79.5739L83.672 79.7702L77.784 76.3551L38.3738 53.6275L32.4858 50.2125L14.39 60.6538L14.1152 60.4968H14.2722L32.6428 49.8984L32.8391 49.9769L38.3738 53.1957L38.727 53.392L77.784 75.9626L78.1373 76.1589L84.0646 79.5739Z",
    fill: "#2D2F42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6712 79.7706L65.6147 90.212L52.1508 82.4791L27.1072 67.9946L14.3892 60.6543L32.4849 50.2129L38.3729 53.6279L77.7832 76.3556L83.6712 79.7706Z",
    fill: "#2C2E41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4536 72.9796L82.3751 73.2936L81.7863 73.6469L43.2004 51.3903L43.0826 51.3118L42.9648 50.5267L43.0041 50.3697L43.0434 50.2519V50.1342L43.0826 50.0949V50.0557L82.4929 72.7833L82.4536 72.9011V72.9796Z",
    fill: "#222433"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2015 51.39L81.7874 73.6466L81.7089 73.6859L42.3379 50.9189L42.8482 51.1937L43.0837 51.3115L43.2015 51.39Z",
    fill: "#836B50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2885 82.9888L38.3741 90.4077L13.8408 76.2372L26.7552 68.8184L51.2885 82.9888Z",
    fill: "#2B2A38"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7011 99.6452L55.1596 97.3527C53.2892 98.182 51.7399 98.1423 49.6576 97.3527L1.05751 69.3847C0.396728 69.006 0.256611 68.537 0.140529 67.5508C-0.176284 70.0291 0.0069488 70.978 1.05751 71.6772L49.6576 99.6452C51.6466 100.341 52.7592 100.382 54.7011 99.6452Z",
    fill: "url(#paint0_linear_2_31178)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8447 43.2256L39.0017 43.3041L38.6484 43.2648L38.8447 43.2256Z",
    fill: "#3D4248"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6427 49.8588V49.898L14.2721 60.4964H14.1151L14.0366 60.4179L32.0931 49.9765L32.4857 49.7803L32.6427 49.8588Z",
    fill: "#232535"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 49.3887L32.6414 49.8597L32.4844 49.7812V49.3887Z",
    fill: "#56463B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4849 49.3887V49.7812L32.0924 49.9775L14.0359 60.4188L13.6826 60.2226L32.0924 49.5849L32.4849 49.3887Z",
    fill: "#2B2D3E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.754 68.819L13.8396 76.2378L13.6826 76.1593L26.5577 68.7012L26.754 68.819Z",
    fill: "#252434"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5464 38.6663L48.7407 16.2002L43.6973 43.2512L84.0445 66.6343L89.5464 38.6663Z",
    fill: "#EAEAEC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2333 36.5567L49.5022 21.7061L45.542 41.5069L72.2731 56.8525L76.2333 36.5567Z",
    fill: "#8CCDDE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5465 38.6663L48.7407 16.2002L48.2822 18.9511L89.088 41.4172L89.5465 38.6663Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31178",
    x1: 4.26702,
    y1: 70.7602,
    x2: 52.8671,
    y2: 98.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373641"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/Laptop.6fc28764eae0fc29aa2c4bd653efb0ae.svg";
export { ForwardRef as ReactComponent };